import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  CALENDAR_VIEW_MODE,
  CalendarView,
  DATE_FORMAT,
  LOCALIZATION_LOCALE,
  MONTH_FORMAT,
  WEEKDAY,
} from '../models';
import { DateTimeUtils } from '../utils';

@Pipe({
  name: 'calendarDateRangeFormatter',
  pure: false,
})
export class CalendarDateRangeFormatterPipe implements PipeTransform {
  private readonly weekdayAsStr = [
    WEEKDAY.SUNDAY,
    WEEKDAY.MONDAY,
    WEEKDAY.TUESDAY,
    WEEKDAY.WEDNESDAY,
    WEEKDAY.THURSDAY,
    WEEKDAY.FRIDAY,
    WEEKDAY.SATURDAY,
  ];

  constructor(private translateService: TranslateService) {}

  transform(value: CalendarView): string {
    if (!value?.viewMode) {
      return '';
    }
    let resultDate = this.getResult(
      value,
      this.translateService.currentLang as LOCALIZATION_LOCALE
    );

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(
        value,
        this.translateService.currentLang as LOCALIZATION_LOCALE
      );
    });

    return resultDate;
  }

  private getResult(
    input: CalendarView,
    currentLang: LOCALIZATION_LOCALE
  ): string {
    switch (input.viewMode) {
      case CALENDAR_VIEW_MODE.MONTH:
        return DateTimeUtils.formatDateToString(
          input.fromDate,
          this.getMonthFormat(currentLang)
        );
      case CALENDAR_VIEW_MODE.AGENDA:
      case CALENDAR_VIEW_MODE.WEEK: {
        const from = DateTimeUtils.formatDateToString(
          input.fromDate,
          this.getDateFormat(currentLang)
        );
        const to = DateTimeUtils.formatDateToString(
          input.toDate,
          this.getDateFormat(currentLang)
        );
        return `${from} - ${to}`;
      }
      default: {
        const weekday = input.fromDate?.getDay()
          ? this.translateService.instant(
              `pipes.weekday.${this.weekdayAsStr[input.fromDate.getDay()]}`
            )
          : null;

        const dateStr = DateTimeUtils.formatDateToString(
          input.fromDate,
          this.getDateFormat(currentLang)
        );

        if (!weekday) {
          return dateStr;
        }

        return `${weekday} ${dateStr}`;
      }
    }
  }

  private getMonthFormat(selectedLang: LOCALIZATION_LOCALE): MONTH_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return MONTH_FORMAT.MONTH_FORMAT_VN;
      case LOCALIZATION_LOCALE.DE:
        return MONTH_FORMAT.MONTH_FORMAT_DE;
      case LOCALIZATION_LOCALE.US:
        return MONTH_FORMAT.MONTH_FORMAT_US;
      default:
        return MONTH_FORMAT.MONTH_FORMAT_DE;
    }
  }

  private getDateFormat(selectedLang: LOCALIZATION_LOCALE): DATE_FORMAT {
    switch (selectedLang) {
      case LOCALIZATION_LOCALE.VN:
        return DATE_FORMAT.DATE_FORMAT_VN;
      case LOCALIZATION_LOCALE.DE:
        return DATE_FORMAT.DATE_FORMAT_DE;
      case LOCALIZATION_LOCALE.US:
        return DATE_FORMAT.DATE_FORMAT_US;
      default:
        return DATE_FORMAT.DATE_FORMAT_BACKEND;
    }
  }
}
